import { COMMISSION_STATS_PATH, TRADED_SYMBOLS_PATH } from '../../../constants/apiPaths'
import AbstractService from '../../../services/AbstractService'
import { ServerResponse } from '../../../types'

import { CommissionStats, TradedSymbols } from './commissionComparisonTypes'

class CommissionComparisonServiceClass extends AbstractService {
  getSymbols = (accountId: number) =>
    this.request<ServerResponse<TradedSymbols>>(TRADED_SYMBOLS_PATH, 'post', true, {
      accountId,
    })

  getCommissionStats = (accountId: number, symbol: string) =>
    this.request<ServerResponse<CommissionStats>>(COMMISSION_STATS_PATH, 'post', true, {
      accountId,
      symbol,
    })
}

export const CommissionComparisonService = new CommissionComparisonServiceClass()
